<template>
    <div>
        <h1 class="text-center mt-4 d-none d-lg-block">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de PRISMA PAPELERIA / PAPELIA
        </h1>
        <h4 class="text-center mt-4 d-lg-none">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de PRISMA PAPELERIA / PAPELIA
        </h4>
        <div class="card mt-lg-5 mt-3">
            <div class="card-header text-center bg-custom text-white h5">
                <b-icon icon="info-circle"></b-icon>
                Ponemos a su disposici&oacute;n nuestro portal en l&iacute;nea para agilizar el proceso de facturaci&oacute;n
            </div>
            <div class="card-body px-md-5 py-4">
                <p class="card-text">Estimado cliente, para brindarle este servicio y apeg&aacute;ndonos a los requerimientos del SAT
                    referente a la facturaci&oacute;n CFDI 4.0, será necesario que los siguientes datos y condiciones sean
                    fieles a su Constancia de Situaci&oacute;n Fiscal actual:</p>
                <ul>
                    <li>RFC.</li>
                    <li>Razón Social.</li>
                    <li>Domicilio.</li>
                    <li>Código postal.</li>
                    <li>Régimen Fiscal.</li>
                </ul>
                <p class="card-text">
                    As&iacute; mismo le informamos que, en apego a las reglas y condiciones emitidas por el SAT:
                </p>
                <ul>
                    <li>La facturaci&oacute;n se realiza con notas de venta cuya fecha sea del mes en curso, teniendo
                        como tiempo m&aacute;ximo tres d&iacute;as naturales despu&eacute;s de finalizado el mes para poder
                        emitirla. <br>
                        <b>NOTA:</b> Despu&eacute;s de transcurrido este tiempo, ya no ser&aacute; posible emitir su factura.</li>
                    <li>El servicio de facturaci&oacute;n solo permite una factura por nota de venta.</li>
                </ul>
                <p class="card-text">
                    Es importante aclarar que, una vez emitida su factura, ya no habr&aacute; posibilidad de
                    cancelaciones ni modificaciones, por esta raz&oacute;n, le sugerimos revisar que la informaci&oacute;n
                    ingresada sea la correcta.
                </p>
                <p class="card-text text-center">
                    Para m&aacute;s informaci&oacute;n y aclaraciones, favor de comunicarse a: <br>
                    <a href="mailto:ventas@papelia.com.mx">ventas@papelia.com.mx</a> <br>
                    665-654-1374 <br>
                    ¡O a nuestro chat en l&iacute;nea!
                </p>
       
                <router-link tag="a" :to="{ name: 'Invoice' }" class="btn btn-custom">
                    <b>Facturar</b>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartAhued',
    }
    
</script>

